import type { JSX, ReactNode } from 'react';
import { Alert, Box } from '@ksyos/design-system';

type AlertCheckboxProps = Readonly<{
    checked?: boolean;
    children?: ReactNode;
    hasError?: boolean;
    hasIcon?: boolean;
    onChange: (checked: boolean) => void;
    text: string;
    title: string;
    titleDanger?: string;
}>;

export function AlertCheckbox(props: AlertCheckboxProps): JSX.Element {
    const { checked, children, hasError, onChange, text, title, titleDanger, hasIcon } = props;

    return (
        <Alert
            appearance={hasError ? 'warning' : 'info'}
            className={hasError ? 'has-danger' : ''}
            hasIcon={hasIcon}
        >
            {(hasError ? titleDanger : null) || title}
            <Alert.Checkbox
                checked={Boolean(checked)}
                label={
                    <Alert.Text
                        as="span"
                        size="sm"
                    >
                        {text}
                    </Alert.Text>
                }
                onChange={(event) => onChange(event.target.checked)}
                sx={{ mt: 2 }}
            />
            {children ? <Box mt={2}>{children}</Box> : null}
        </Alert>
    );
}
